import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGetUserPermissionsQuery } from './SettingsApi';

/**
 * Route guard that allows access if the user is a SuperAdmin
 * OR is an admin-role user with the specified sub-category permission.
 * User-role users are always blocked regardless of group permissions.
 */
export default function RequirePermission({
  permission,
  children,
}: {
  permission: string;
  children: React.ReactNode;
}) {
  const { data, isLoading } = useGetUserPermissionsQuery();
  const location = useLocation();

  if (isLoading) {
    return <div></div>;
  }

  const isSuperAdmin = data?.user?.isSuperAdmin === true;
  const isAdminRole = data?.user?.role?.toLowerCase() === 'admin';
  const hasPermission =
    isAdminRole &&
    (data?.subcategoryPermissions as Record<string, boolean>)?.[permission] === true;

  if (!isSuperAdmin && !hasPermission) {
    return <Navigate to="/admin/settings" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
